export class ImageLoader {
  public loadImage(url: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = reject;

      image.src = url;
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/ImageLoader.ts